import GdPermissionDialog, {
  GD_PERMISSION_TYPE,
} from "@/components/GdPermissionDialog";
import { NormalizedError } from "./errorHandle";

/**
 * 稿定租户权限问题处理
 * @param error 错误信息
 */
export const handlePermission = (error: NormalizedError) => {
  const { config, code, message } = error;
  const { ignoreGdPermission } = config?.options || {};

  // 稿定租户权限问题处理
  if (code === 403 && !ignoreGdPermission) {
    switch (message) {
      case "权限校验失败":
        GdPermissionDialog.open({
          type: GD_PERMISSION_TYPE.noauth,
          operation: "当前操作",
        });
        break;

      case "已被踢出组织":
        GdPermissionDialog.open({
          type: GD_PERMISSION_TYPE.remove,
          operation: "当前操作",
        });
        break;
      case "角色权限不足":
        GdPermissionDialog.open({
          type: GD_PERMISSION_TYPE.visitor,
          operation: "当前操作",
        });
        break;
      case "组织不存在或已解散":
        GdPermissionDialog.open({
          type: GD_PERMISSION_TYPE.noorg,
        });
        break;
      default:
        break;
    }
  }
};
